import { useMemo } from 'react'

import {
  GetDataForWidgetQuery,
  GetDataForWidgetQueryVariables,
  GetDataForWidgetInput,
  WidgetDataBucketFragment,
} from 'types/graphql'

import { useActiveOrgId } from 'src/hooks/use-active-org-id'
import { QueryKey, UseQueryOptions, useQuery } from 'src/utils/queryClient'

const GetDataForWidget = gql`
  query GetDataForWidgetQuery($input: GetDataForWidgetInput!) {
    getDataForWidget(input: $input) {
      buckets {
        ...WidgetDataBucketFragment
      }
      bucketSize
    }
  }
`

export const useGetDataForWidgetQuery = (
  input: GetDataForWidgetInput,
  options?: UseQueryOptions<GetDataForWidgetQuery, GetDataForWidgetQueryVariables>
) => {
  const activeOrgId = useActiveOrgId()
  const { data, ...rest } = useQuery<GetDataForWidgetQuery, GetDataForWidgetQueryVariables>({
    ...options,
    queryKey: [QueryKey.WidgetData, input, activeOrgId],
    queryDocument: GetDataForWidget,
    variables: { input: { ...input, organizationId: input.organizationId ?? activeOrgId } },
    enabled: !!activeOrgId && (options?.enabled ?? true),
  })

  const buckets: WidgetDataBucketFragment[] = useMemo(
    () => data?.getDataForWidget?.buckets ?? [],
    [data]
  )

  return { buckets, bucketSize: data?.getDataForWidget?.bucketSize, ...rest }
}
